var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewRecinformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13041",
    "data-name": "Path 13041",
    d: "M22.286,27.857V21H18.857v1.714h1.714v5.143H18v1.714h6.857V27.857Z",
    transform: "translate(-6.429 -7.714)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13042",
    "data-name": "Path 13042",
    d: "M23.036,12a1.286,1.286,0,1,0,1.286,1.286A1.286,1.286,0,0,0,23.036,12Z",
    transform: "translate(-8.036 -3.857)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13043",
    "data-name": "Path 13043",
    d: "M15,27A12,12,0,1,1,27,15,12,12,0,0,1,15,27ZM15,4.714A10.286,10.286,0,1,0,25.286,15,10.286,10.286,0,0,0,15,4.714Z",
    transform: "translate(0 0)",
    fill: "#ffa200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRecinformation);
export default __webpack_public_path__ + "static/media/viewRecinformation.68198c54781cfb23865c5f0d18aa5d1f.svg";
export { ForwardRef as ReactComponent };